<script setup lang="ts">
import { computed } from "vue"

const props = defineProps({
  displayBlock: { type: Boolean, default: false },
  justifyEnd: { type: Boolean, default: false },
})

const classes = computed(() => {
  const list = []
  if (props.displayBlock) {
    list.push("d-grid")
    list.push("gap-2")
  } else {
    list.push("d-flex")
    if (props.justifyEnd) {
      list.push("justify-content-end")
    } else {
      list.push("justify-content-start")
    }
  }
  return list.join(" ")
})
</script>

<template>
  <div class="action-container" :class="classes">
    <slot />
  </div>
</template>

<style scoped>
.action-container {
  margin-top: 2rem;
}
</style>
